module.exports = __webpack_public_path__ + "static/board-13-b0fb39e8f2be7578b6b7193e990e92ff.jpg";